var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/utils/cartdrawer.js
var cartDrawer = class {
  constructor() {
    __publicField(this, "handleOutsideClick", (event) => {
      if (event.target === this.curtain)
        this.close();
    });
    this.cartDrawerElement = document.querySelector("cart-drawer");
    this.curtain = document.querySelector("#curtain");
  }
  open() {
    const desktopRecommendations = document.querySelector("#desktop-recommendations");
    this.cartDrawerElement.setAttribute("aria-hidden", "false");
    this.curtain.setAttribute("aria-hidden", "false");
    this.curtain.addEventListener("click", this.handleOutsideClick);
    setTimeout(() => {
      desktopRecommendations.setAttribute("aria-hidden", "false");
      desktopRecommendations.style.visibility = "visible";
    }, 250);
  }
  close() {
    const desktopRecommendations = document.querySelector("#desktop-recommendations");
    desktopRecommendations.setAttribute("aria-hidden", "true");
    setTimeout(() => {
      this.cartDrawerElement.setAttribute("aria-hidden", "true");
      this.curtain.setAttribute("aria-hidden", "true");
      this.curtain.removeEventListener("click", this.handleOutsideClick);
      desktopRecommendations.style.visibility = "hidden";
    }, 250);
  }
};
var cartdrawer_default = new cartDrawer();

// src/extenders/cart-drawer.js
var CartDrawer = class extends HTMLElement {
  constructor() {
    super();
    this.closeToggle = this.querySelector("#cartdrawer-close");
    this.closeToggle.addEventListener("click", () => {
      cartdrawer_default.close();
    });
  }
};
if (customElements.get("cart-drawer") === void 0) {
  customElements.define("cart-drawer", CartDrawer);
}
